export const SET_USER_FOUND = 'explore/SET_USER_FOUND';
export const SEARCH = 'explore/SEARCH'